import { addRest } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function ntcTemperatureCurves2Str(obj_id, obj_dict) {
    const xl = obj_dict.x.map((x) => x & 0xffff);
    const xh = obj_dict.x.map((x) => (x & 0xffff) >> 16);
    const y = obj_dict.y.map((y) => y * 10 + 2730);
    return new ObjectLine(obj_dict.id, obj_id, [xl, xh, y, ...(obj_dict.rest || [])]);
}
function ntcTemperatureCurvesFromStr(id, params) {
    const x = params[0]
        .map((_, i) => ({
        xl: params[0][i],
        xh: params[1][i],
    }))
        .map((v) => v.xl | (v.xh << 16));
    const y = params[2].map((x) => x / 10 - 273);
    return {
        id: id,
        x: x,
        y: y,
        ...addRest(params, 3),
    };
}
export const ntc_temperature_curve_parser = {
    toStr: ntcTemperatureCurves2Str,
    fromStr: ntcTemperatureCurvesFromStr,
};
